<template>
    <div class="position-relative h-100">
        <main class="budget">
            <div class="container">
                <MonthWizard :budget="budget" :date="date" @planned="redirectToBudget" />
            </div>
        </main>
    </div>
</template>

<script>
import "../../components/Budget/style.scss";
import MonthWizard from "../../components/Budget/MonthWizard.vue";
import { mapActions, mapState, mapGetters } from 'vuex';
import { EventBus } from '../../event-bus';

export default {
    name: "BudgetMonth",

    components: {
        MonthWizard,
    },

    data: function() {
        return {
            budget: this.$route.params.id,
            date: this.$route.params.date,
        };
    },

    methods: {
        redirectToBudget(data) {
            EventBus.$emit('show-alert', data.message ? data.message : $t('Месяц запланирован'), 'success');

            this.$router.push(`/budget/${this.budget}`);
        }
    },
}
</script>

<style lang="scss">
.wizard {
    margin-top: 20px;
    
    .wizard-header {
        h3 {
            font-size: 23px;
        }

        margin-bottom: 15px;
    }

    .wizard-container {
        padding: 0 15px;
        background: #fff;
        box-shadow: 0 4px 8px 0 rgba(48, 82, 120, .08);
        border-radius: 3px;

        p {
            font-size: 14px;
        }
    }
}
</style>